/** @format */

// src/components/EntriesArchive.js
import { useEffect } from '@wordpress/element';

const EntriesArchive = ({ archiveEntries = [], archiveLoading = false, onFetchArchive }) => {
	// Fetch the archive data only once when this component mounts (lazy loading with cache checking)
	useEffect(() => {
		if (archiveEntries.length === 0 && onFetchArchive) {
			onFetchArchive();
		}
	}, []);

	if (archiveLoading) {
		return (
			<div className="text-center py-5">
				<div className="spinner-border text-primary" role="status"></div>
				<p className="text-muted small mt-2">Compiling entry records...</p>
			</div>
		);
	}

	if (archiveEntries.length === 0) {
		return (
			<div className="alert alert-info border-0 shadow-sm p-4 text-center mt-5">
				<i className="fas fa-folder-open text-muted fa-2x mb-2"></i>
				<h5 className="fw-bold text-dark">No Historical Entries Discovered</h5>
				<p className="text-muted small mb-0">No event entries or relay formations have been processed into event definitions yet.</p>
			</div>
		);
	}

	return (
		<div className="advanced-mm-entries-archive-wrapper bg-white rounded shadow-sm border p-3">
			<div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3 border-bottom pb-2">
				<h5 className="fw-bold text-dark mb-0">Entries Archives</h5>
			</div>
			<div className="table-responsive">
				<table className="table table-hover align-middle mb-0 small">
					<thead className="table-light text-uppercase text-secondary">
						<tr>
							<th>Competition Workspace</th>
							<th className="text-center" style={{ width: '150px' }}>
								Active Entries
							</th>
							<th className="text-end" style={{ width: '200px' }}>
								Actions
							</th>
						</tr>
					</thead>
					<tbody>
						{archiveEntries.map((meet) => (
							<tr key={meet.meeting_id}>
								<td>
									<div className="d-flex align-items-center gap-2">
										<i className="fas fa-calendar-alt text-muted"></i>
										<span className="fw-bold text-dark">{meet.meet_name}</span>
									</div>
								</td>
								<td className="text-center">
									<span className="badge lh-sm bg-primary bg-opacity-10 text-primary px-2 py-1 fw-bold rounded-pill">
										{meet.total_entries} {parseInt(meet.total_entries, 10) === 1 ? 'Entry' : 'Entries'}
									</span>
								</td>
								<td className="text-end">
									<a href={`${window.location.origin}/meetings/${meet.meet_slug}/?tab=register`} className="btn btn-sm btn-outline-primary rounded-2 fw-bold px-3">
										View Workspace <i className="fas fa-arrow-right small ms-1"></i>
									</a>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default EntriesArchive;
